import axios from 'axios';
class FontManager {
    static instance;

    fonts = [];
    loadedFontFaces = {};

    constructor() {
        if (FontManager.instance) {
            return FontManager.instance;
        }

        FontManager.instance = this;
    }

    async loadFonts() {
        // const fonts = (await axios.get(`${GetBaseUrl()}/api/font/list`)).data.list;
        const fonts = (await axios.get(`https://videomonster.com/api/font/list`)).data.list;
        this.fonts = fonts;
    }

    getFonts() {
        return this.fonts;
    }

    async loadFontFace(postscriptName) {
        if (this.loadedFontFaces[postscriptName] instanceof FontFace) {
            return this.loadedFontFaces[postscriptName];
        }

        const font = this.fonts.find(font => font.postscriptName === postscriptName);
        if (!font) return null

        function arrayBufferToBase64(buffer, callback) {
            return new Promise((resolve, reject) => {
                const blob = new Blob([buffer], { type: 'application/octet-binary' })
                const reader = new FileReader();
                reader.onload = function (evt) {
                    const dataurl = evt.target.result;
                    resolve(dataurl.substr(dataurl.indexOf(',') + 1))
                };
                reader.onerror = reject
                reader.readAsDataURL(blob)
            })
        }

        const { data: buffer } = await axios.get(font.fileURL, { responseType: 'arraybuffer' });
        const base64 = await arrayBufferToBase64(buffer)
        const dataUrl = `data:font/otf;base64,${base64}`;

        const fontFace = new FontFace(font.postscriptName, `url(${dataUrl})`);
        await fontFace.load()
        document.fonts.add(fontFace)
        
        const dummyTextElement = document.createElement('span')
        dummyTextElement.style.fontFamily = font.postscriptName
        dummyTextElement.style.position = 'absolute'
        dummyTextElement.style.left = '-1000px'
        dummyTextElement.style.top = '-1000px'
        dummyTextElement.textContent = `${font.postscriptName} 1234567890`
        document.body.appendChild(dummyTextElement)

        this.loadedFontFaces[postscriptName] = fontFace;
        return fontFace;
    }
}

const instance = new FontManager();
export default instance;
